import PageHeader from "@/components/page-header";
import { Book1 } from "iconsax-react";
import HeaderDropdown from "./header-dropdown";
import ResourcesList from "./resource-list/resources-list";

const LibraryPage = () => {
  return (
    <>
      <PageHeader
        className="mb-4"
        title="Biblioteca de recursos"
        icon={<Book1 />}
      >
        <HeaderDropdown />
      </PageHeader>

      <ResourcesList />
    </>
  );
};

export default LibraryPage;
